// src/lib/voxToast.js
import { toast } from "sonner";

/**
 * Vox toast vocabulary
 * Centralized so Vox always speaks consistently
 */

export const voxToast = {
  memorySaved() {
    toast.success("Vox will remember that.");
  },

  memoryFailed() {
    toast.error("Vox tried to remember that but couldn’t.");
  },

  taskAdded() {
    toast.success("Task added.");
  },

  taskFailed() {
    toast.error("What task was that again?");
  },

  taskCompleted() {
    toast.success("That’s done!");
  },

  offline() {
    toast.message("Vox is working offline for now.");
  },
};
